import { Injectable, inject, signal } from '@angular/core';
import type { QuotaSampleRow } from '../models/flock-telemetry.models';
import {
  PACE_HISTORY_HOURS,
  paceHistoryDue,
} from '../wallboard/pace-history.logic';
import { RynBridgeService } from './ryn-bridge.service';

/**
 * The bridge's stored weekly usage samples (US 34691), shared by the Roost
 * Seats and Accounts pages so they build the same 7d basis as the wallboard
 * (`paceSamplesFor`). One read serves every page; it is re-read only once it
 * is `PACE_HISTORY_REFRESH_MS` old, however often the pages poll quota.
 */
@Injectable({ providedIn: 'root' })
export class QuotaPaceHistoryService {
  private readonly bridge = inject(RynBridgeService);
  private readAtMs: number | null = null;

  /** Oldest first per account; empty until the first read lands. */
  readonly rows = signal<QuotaSampleRow[]>([]);

  /** Call on every quota refresh. A failed read is retried on the next call;
   * until then the pages keep the since-open average. */
  refresh(nowMs = Date.now()): void {
    if (!paceHistoryDue(this.readAtMs, nowMs)) return;
    this.readAtMs = nowMs;
    this.bridge.getQuotaSamples(PACE_HISTORY_HOURS).subscribe({
      next: (rows) => this.rows.set(rows),
      error: () => (this.readAtMs = null),
    });
  }
}
